import React from 'react';
import AssetMain from '../../components/assetcomponents/AssetMain';

function AssetRegister({ renderPageContent }) {
    return (
        <>
            {/*Dynamic content goes here */}
            <AssetMain renderPageContent={renderPageContent} />

        </>
    )
};

export default AssetRegister;